import * as axiosBaseClient from './axiosBaseClient';
import configurations from '../config.json';
import { apiUrl } from "../httpCommon";
import * as reqHeaderConstants from '../constants/reqHeaderConstants';

const baseURL = apiUrl();

export const getDraftSupplier = (supplierId) => {
  const url = `${baseURL}${configurations.DRAFT_SUPPLIER_END_POINT}?supplierId=${supplierId}`;
  return axiosBaseClient.httpGet(url);
};

export const createSupplier = (reqBody, headers = reqHeaderConstants.defaultHeaders) => {
  const url = `${baseURL}${configurations.SUPPLIER_END_POINT}`;
  return axiosBaseClient.httpPost(url, reqBody, headers);
};
